package com.jingfangpai.common.data.serializer

import com.jingfangpai.common.data.type.DateTime
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

@Serializer(forClass = DateTime::class)
actual class DateTimeSerializer : KSerializer<DateTime> {
     override fun serialize(encoder: Encoder, value: DateTime) {
        encoder.encodeLong(value.getTime())
    }

     override fun deserialize(decoder: Decoder): DateTime {
        return DateTime(decoder.decodeLong())
    }

     override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("DateTime", PrimitiveKind.INT)
}

